/* eslint-disable jira/choreographer/message-id-by-folder-structure */
/* eslint-disable jira/naming/disallow-filenames */

// eslint-disable-next-line jira/filename-case
import type { FlagConfiguration } from '@atlassian/jira-flags';

import { defineMessage } from '@atlassian/jira-intl';

const title = defineMessage({
	id: 'redirect.legacy-routing.flags.error.title',
	defaultMessage: "We can't find the page you're looking for",
	description: 'Title of the flag that tells the user the page could not be found',
});

const description = defineMessage({
	id: 'redirect.legacy-routing.flags.error.description',
	defaultMessage:
		"Check your spelling in the address bar. Or, try opening this site's home page to search or browse for the content.",
	description: 'Message shown in the flag that gives user possible actions to recover from error',
});

const goHome = defineMessage({
	id: 'redirect.legacy-routing.flags.error.go-home',
	defaultMessage: 'Go to the homepage',
	description: 'Action on the flag that allows user to return to the home page',
});

export const errorFlag = (): FlagConfiguration => ({
	type: 'error',
	title,
	description,
	messageId: 'common.redirect.legacy-routing.flags.flag.error.error-flag',
	messageType: 'transactional',
	actions: [
		{
			content: goHome,

			// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
			onClick: () => window.location.assign('/'),
		},
	],
});
